import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

import { StockMovementsPage } from '@/features/reports/pages/stock-movements-page'
import { PresetEnum, UnitsEnum, ViewEnum } from '@/features/reports/schemas'
import { monthBoundsKyivIso } from '@/lib/format/date'
import { messages } from '@/lib/i18n/messages'

const SearchSchema = z.object({
  // Function defaults run on every parse, so an app left open over the
  // month change opens the report on the new month.
  period_from: z.string().default(() => monthBoundsKyivIso().from),
  period_to: z.string().default(() => monthBoundsKyivIso().to),
  preset: PresetEnum.default('by_warehouse'),
  view: ViewEnum.default('movements'),
  units: UnitsEnum.default('pieces'),
  warehouse_ids: z.array(z.coerce.number()).optional(),
  project_ids: z.array(z.coerce.number()).optional(),
  group_ids: z.array(z.coerce.number()).optional(),
})

// `<Shell>` and `requireAuth` live on the shared `/_app` layout, so this leaf
// renders only the page — the sidebar stays mounted across every global
// navigation (see routes/_app.tsx).
export const Route = createFileRoute('/_app/reports/stock-movements')({
  validateSearch: SearchSchema,
  staticData: { crumb: messages.reports.stockMovements.title },
  component: StockMovementsPage,
})
